export interface V1EquipmentSlotDefinition {
  slotId: number;
  equipmentType: number;
  atlasIndex: number;
  column: number;
  row: number;
  fallbackName: string;
}

/**
 * APK-compatible 15-slot layout.
 *
 * Equipment types remain the 13 maintainable families in equipment.tsv.
 * Gloves and rings each expand to two runtime slots.
 */
export const V1_EQUIPMENT_SLOTS: readonly V1EquipmentSlotDefinition[] = [
  { slotId: 1, equipmentType: 1, atlasIndex: 0, column: 0, row: 2, fallbackName: "武器" },
  { slotId: 2, equipmentType: 2, atlasIndex: 1, column: 2, row: 1, fallbackName: "项链" },
  { slotId: 3, equipmentType: 3, atlasIndex: 2, column: 2, row: 0, fallbackName: "头盔" },
  { slotId: 4, equipmentType: 4, atlasIndex: 3, column: 2, row: 2, fallbackName: "衣服" },
  { slotId: 5, equipmentType: 5, atlasIndex: 4, column: 1, row: 2, fallbackName: "左手套" },
  { slotId: 6, equipmentType: 5, atlasIndex: 5, column: 3, row: 2, fallbackName: "右手套" },
  { slotId: 7, equipmentType: 6, atlasIndex: 6, column: 1, row: 3, fallbackName: "左戒指" },
  { slotId: 8, equipmentType: 6, atlasIndex: 7, column: 3, row: 3, fallbackName: "右戒指" },
  { slotId: 9, equipmentType: 7, atlasIndex: 8, column: 2, row: 4, fallbackName: "鞋子" },
  { slotId: 10, equipmentType: 8, atlasIndex: 9, column: 2, row: 3, fallbackName: "腰带" },
  { slotId: 11, equipmentType: 9, atlasIndex: 10, column: 4, row: 2, fallbackName: "宝石" },
  { slotId: 12, equipmentType: 10, atlasIndex: 11, column: 0, row: 1, fallbackName: "翅膀" },
  { slotId: 13, equipmentType: 11, atlasIndex: 12, column: 0, row: 3, fallbackName: "勋章" },
  { slotId: 14, equipmentType: 12, atlasIndex: 13, column: 4, row: 1, fallbackName: "神器" },
  { slotId: 15, equipmentType: 13, atlasIndex: 14, column: 4, row: 3, fallbackName: "坐骑" },
] as const;

const SLOT_BY_ID = new Map(
  V1_EQUIPMENT_SLOTS.map((slot) => [slot.slotId, slot]),
);

export const v1EquipmentSlot = (
  slotId: number,
): V1EquipmentSlotDefinition | undefined => SLOT_BY_ID.get(slotId);

export const v1EquipmentSlotsForType = (
  equipmentType: number,
): readonly V1EquipmentSlotDefinition[] =>
  V1_EQUIPMENT_SLOTS.filter((slot) => slot.equipmentType === equipmentType);

export const v1PrimaryEquipmentSlot = (
  equipmentType: number,
): V1EquipmentSlotDefinition | undefined =>
  v1EquipmentSlotsForType(equipmentType)[0];
